import { FC, ReactNode, createContext, useContext, useState } from 'react';

import { useGetPartnerCustomMovements } from 'modules/partners/hooks/useGetPartnerCustomMovements';

import { CustomMovementsSectionContextType } from '../types/CustomMovementsSectionContextType';
import { customMovementsSectionInitValue } from '../constants/customMovementsSectionInitValue';

const CustomMovementsSectionContext =
  createContext<CustomMovementsSectionContextType>(
    customMovementsSectionInitValue
  );

export const CustomMovementsSectionProvider: FC<{
  children: ReactNode;
  partnerId: string;
}> = ({ children, partnerId }) => {
  const [page, setPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);

  const { data: customMovementsData, isLoading: isLoadingCustomMovements } =
    useGetPartnerCustomMovements({
      partnerId,
      page,
      rowsPerPage,
    });

  const handleChangePage = (newPage: number) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (newRowsPerPage: number) => {
    setRowsPerPage(newRowsPerPage);
    setPage(1);
  };

  return (
    <CustomMovementsSectionContext.Provider
      value={{
        data: {
          customMovements: customMovementsData.customMovements || [],
          customMovementsTotal: customMovementsData.customMovementsTotal || 0,
          page,
          rowsPerPage,
          isLoadingCustomMovements,
        },
        actions: {
          handleChangePage,
          handleChangeRowsPerPage,
        },
      }}
    >
      {children}
    </CustomMovementsSectionContext.Provider>
  );
};

export const useCustomMovementsSection = () => {
  const context = useContext(CustomMovementsSectionContext);
  if (!context) {
    throw new Error(
      'useCustomMovementsSection must be used within a CustomMovementsSectionProvider'
    );
  }
  return context;
};
